var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconAvailabilityNotAvailable = function SvgIconAvailabilityNotAvailable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#f44336",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.918 5.061 9 7.98 6.082 5.063a.72.72 0 0 0-1.02 0l-.05.055a.72.72 0 0 0 .05.965L7.979 9l-2.916 2.919a.72.72 0 0 0 .51 1.231l.07-.003a.724.724 0 0 0 .44-.208L9 10.02l2.919 2.918a.72.72 0 0 0 1.231-.51l-.003-.07a.724.724 0 0 0-.208-.44L10.02 9l2.918-2.918a.72.72 0 1 0-1.02-1.02z",
    fill: "#FFF"
  }))));
};

export default SvgIconAvailabilityNotAvailable;